import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbInputDatepicker, NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-date-range-selection',
  templateUrl: './date-range-selection.component.html',
  styleUrls: ['./date-range-selection.component.scss'],
})
export class DateRangeSelectionComponent implements OnInit {

  @Input() from;
  @Input() to;
  @Output() datesSelectionApplied = new EventEmitter();
  @Input() options = {
    position: 'bottom'
  }
  bothDatesApplied = false;

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate;
  toDate: NgbDate | null = null;
  applyText = this.translate.instant('LABELS.APPLY');
  clearText = this.translate.instant('LABELS.CLEAR');
  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit() {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.applyText = this.translate.instant('LABELS.APPLY');
      this.clearText = this.translate.instant('LABELS.CLEAR');
    });

    if (this.from) {
      const frmDate = moment(this.from);
      this.fromDate = this.getNgbDateFromMoment(frmDate);
      const toDate = moment(this.to);
      this.toDate = this.getNgbDateFromMoment(toDate);
    }
  }

  
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && (date.after(this.fromDate) || date.equals(this.fromDate))) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    this.checkForValidDates();
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }

  clearDates() {
    this.fromDate = null;
    this.toDate = null;
    this.from = null;
    this.to = null;
    this.bothDatesApplied = true;
    this.datesSelectionApplied.emit();
  }

  applyDates() {
    if (this.bothDatesApplied) {
      this.datesSelectionApplied.emit({
        from: this.from, to: this.to
      });
    }
  }

  private getNgbDateFromMoment(dtMoment) {
    return new NgbDate(dtMoment.year(), dtMoment.month(), dtMoment.date());
  }

  private setInputDates(){
    this.from = moment(new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day));
    this.to = moment(new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day));
  }

  private checkForValidDates() {
    if (this.fromDate && this.toDate) {
      this.bothDatesApplied = true;
      this.setInputDates();
    } else {
      this.bothDatesApplied = false;
    }
  }



}
